module.exports = __webpack_public_path__ + "img/theoldsteak.d2dd6917.jpg";